var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSignIn = function SvgSignIn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15.984 1c.531 0 1 .203 1.406.61.406.405.609.874.609 1.405v13.969c0 .531-.203 1-.609 1.406-.406.406-.875.609-1.406.609H2.015c-.563 0-1.04-.195-1.43-.586a1.945 1.945 0 0 1-.586-1.43v-3.984h2.016v3.984h13.969V3.014H2.015v3.984H-.001V3.014c0-.563.195-1.04.586-1.43.39-.39.867-.586 1.43-.586h13.969V1ZM7.078 13.61l2.578-2.625H0V9.015h9.656L7.078 6.39l1.406-1.406L13.5 10l-5.016 5.016-1.406-1.407Z",
    fill: "currentColor"
  })));
};
export default SvgSignIn;